export default __webpack_public_path__ + "static/media/javascript-06.29e07c5d.png";